import { defineStore } from 'pinia';
import { Messages } from './message-types';
import { LaravelErrorItem } from '../shared/shared-types';

export const useMessageStore = defineStore({
  id: 'message',

  state: () => ({
    messages: {
      success: null,
      error: null,
      errorItems: null,
    } as Messages,
  }),

  getters: {
    // ...
  },

  actions: {
    setMessages(
      success: string | null = null,
      error: string | null = null,
      errorItems: LaravelErrorItem[] | null = null
    ) {
      this.messages = {
        success: success,
        error: error,
        errorItems: errorItems,
      };
    },
  },
});
